import React from 'react';

import { ContextLine } from './context-line';

export type LocaleTextFieldProps = {
    label?: React.ReactNode;
    content: React.JSX.Element;
};

export const LocaleTextField = (props: LocaleTextFieldProps) => {
    const { label, content } = props;

    return (
        <ContextLine
            label={label}
            lineColor="components.language-picker.input.line"
            color="components.language-picker.input.text"
        >
            {content}
        </ContextLine>
    );
};
